// prettier-ignore

const rebrand = process.env.REACT_APP_NEW_WISDOM;
module.exports = {
  colours: {
    black: "#212121",
    "font-dark": rebrand ? "#244A68" : "#4D4D4D",
    "border-grey": rebrand ? "#EBEBEB" : "#90A4B4",
    "d-grey": "#4D4D4D",
    grey: "#6D6E70",
    "l-grey": "#BBBDC0",
    "lighter-grey": "#DFE7EE",
    "m-grey": "#707070",
    "drop-grey": "#ABBED160",
    silver: "#EFEFF0",
    "grey-blue": "#F1FDFF",
    white: "#FFFFFF",
    "off-white": "#eeeeee",
    lilac: "#F5F3FE",
    violet: "#6054B8",
    brand: "#309fb0",
    "brand-darker": rebrand ? "#726FB3" : "#277E8B",
    "m-brand": "#61BFCE",
    "l-brand": "#8FD1DC",
    "blue-hover": "#84C7D1",
    "navy-hover": "#506e86",
    azure: "#8FD1DC",
    sky: "#E8F6F7",
    "d-blue": "#244968",
    "l-blue": "#EEF5FC",
    "sky-grey": "#90A4B4",
    "l-sky-grey": "#CBD6DE",
    "xl-sky-grey": "#F0F4F8",
    "d-green": "#115B43",
    forest: "#1B6E53",
    "m-green": "#009262",
    "whatsapp-green": "#25D366",
    herbal: "#32C997",
    mint: "#84DFC1",
    "l-green": "#F1FBF8",
    orange: "#FE7F2D",
    "m-orange": "#F59556",
    "xl-orange": "#FEDAC4",
    "d-yellow": "#E48900",
    lemon: "#FFA826",
    "m-yellow": "#FFB240",
    straw: "#FFC670",
    sand: "#FFD596",
    "l-yellow": "#FFF8EC",
    "d-red": "#C33025",
    scarlet: "#E84C4E",
    "m-red": "#EA6D6F",
    raspberry: "#F19B9C",
    rubicund: "#FED2D3",
    "l-red": "#FFF2F2",
    transparent: "transparent",
    "brand-purple": "#726FB3",
    "brand-grey": "#D9D9D9",
    "brand-grey-light": "#EBEBEB",
    "navy-blue": "#244A68",
    "navy-blue-light": "#506E86",
    "brand-green": "#009F66",
    "brand-green-light": "#33B285",
  },
};
